
























































































































































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { placeModule } from "@/store/modules/place";
import { appModule } from "../store/modules/app";
import http from "@/http/axios";

@Component
export default class PlaceList extends Vue {
  public search = "";
  public editOldDialog = false;
  public editOldItem = {
    shortcode:"",
    index:"",
    branch_type:"其他",
    branch_name:"",
    netown_device_number:"",
    left:0,
    top:0,
    display:false
  };
  public headers = [
    {
      text: "地區名稱",
      left: true,
      sortable: true,
      value: "branch_name"
    },
    { text: "shortcode", sortable: true, value: "shortcode" },
    { text: "index", sortable: true, value: "index" },
    { text: "地區類型", sortable: true, value: "branch_type" },
    { text: "Netown機器編號", sortable: true, value: "netown_device_number" },
    { text: "x 軸座標", sortable: false, value: "left" },
    { text: "y 軸座標", sortable: false, value: "top" },
    { text: "顯示於地圖上", sortable: true, value: "display" },
    { text: "其他操作", value: "actions", sortable: false },
  ];
  public branch_type_items = [
      {type:'社區'},
      {type:'診所'}, 
      {type:'醫院'}, 
      {type:'政府'}, 
      {type:'其他'}
  ];
  public display_options: [
      { text: '是', value: true },
      { text: '否', value: false }
  ];
  public editDialog = false;
  public editItem = {
    shortcode:"",
    branch_type:"其他",
    branch_name:"",
    netown_device_number:"",
    display:false,
    left: 0,  
    top: 0
  };

  get place() {
    return placeModule.place;
  }
  get loading() {
    return placeModule.loading;
  }
  get totalPlaces() {
    return placeModule.place.length;
  }

  async created() {
    await placeModule.placeList();
  }

  async edit() {
    this.editDialog = true;
  }
  async edit_old(item) {
    this.editOldDialog = true;
    this.editOldItem = JSON.parse(JSON.stringify(item));
  }
  has_value(item){
    return (item===null)
      ? false
      : (item===undefined)
        ? false
        : (item==="")
          ? false
          : true;
  }

  closeEdit() {
    this.editItem = {
      shortcode:"",
      branch_type:"其他",
      branch_name:"",
      netown_device_number:"",
      display:false,
      left: 0,  
      top: 0
    };
    this.editDialog = false;
  }

  closeOldEdit() {
    this.editOldItem = {
      shortcode:"",
      index:"",
      branch_type:"其他",
      branch_name:"",
      netown_device_number:"",
      left:0,
      top:0,
      display:false
    };
    this.editOldDialog = false;
  }

  async saveOldEdit(){
    const params = {
      shortcode:this.editOldItem.shortcode,
      index:this.editOldItem.index,
      display:this.editOldItem.display,
      left:this.editOldItem.left,
      top:this.editOldItem.top
    };
    if(this.has_value(this.editOldItem.netown_device_number)) params['netown_device_number'] = this.editOldItem.netown_device_number;
    if(this.has_value(this.editOldItem.branch_name)) params['branch_name'] = this.editOldItem.branch_name;
    if(this.has_value(this.editOldItem.branch_type)) params['branch_type'] = this.editOldItem.branch_type;
    const result = await http.put("/place", params);
    if (result) {
      if (result.data.status === "Success") {
        appModule.sendSuccessNotice("修改成功");
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
    } else {
      console.error(result.data.status);
    }
    this.closeOldEdit();
    await placeModule.placeList();
  }

  async saveEdit() {

    if(!this.has_value(this.editItem.shortcode) || !this.has_value(this.editItem.branch_name)){
        appModule.sendErrorNotice("請完整填完項目");
    }
    const params = {
        shortcode:this.editItem.shortcode,
        branch_name:this.editItem.branch_name,
        branch_type:this.editItem.branch_type,
        display: this.editItem.display,
        left: this.editItem.left,
        top: this.editItem.top,
    };
    if(this.has_value(this.editItem.netown_device_number)){
        params['netown_device_number'] = this.editItem.netown_device_number;
    }

    const result = await http.post("/place", params);
    if (result) {
      if (result.data.status === "Success") {
        appModule.sendSuccessNotice("修改成功");
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
    } else {
      console.error(result.data.status);
    }
    this.closeEdit();
    await placeModule.placeList();
  }
}
